module.exports = __webpack_public_path__ + "static/img/team4.9bb0463.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/instructors/team4.jpg
// module id = HNl7
// module chunks = 1